import {handleLogout} from "components/utils"; import React, {useEffect, useRef, useState} from 'react';

import {Button, Col, Form, Modal, Row, Table, Tabs, Tab, Card, Accordion} from "react-bootstrap";
import axios from "axios";
import {TimelineView} from "./TimelineView";
import {CaseDetailsView} from "./CaseDetailsView";
import {BillView} from "../inventory/billing/BillView";
import {AddVisitView} from "./subCategories/visit/AddVisitView";
import {DischargeSummary} from "./subCategories/DischargeSummary";
import {AddRecordView} from "./subCategories/records/AddRecordView";
import {AddProcedureView} from "./subCategories/procedure/AddProcedureView";
import {AddBedView} from "./subCategories/bed/AddBedView";
import {random} from "nanoid";
import {CaseFile} from "./subCategories/CaseFile";
import {AddDischargeDetailsView} from "./subCategories/discharge/AddDischargeDetailsView";
import {hasPermissions, IPD_BILLING, IPD_CASE_MGT} from "../permissions";
import {useCookies} from "react-cookie";
import {CaseConsentFormsView} from "./consentForms/case/CaseConsentFormsView";
import {IpdUploadView} from "./IpdUploadView";


export const CaseView = (props: { cookieEntityQr: string, case: any, clearCaseId: any, doctors: Array<any> }) => {

    const [loading, setLoading] = useState(false)
    const [oldCases, setOldCases] = useState([])
    const [stateTracker, setStateTracker] = useState(random(2))
    const [billStatus, setBillStatus] = useState<string>()
    const [caseDetails, setCaseDetails] = useState<any>()
    const [cookie] = useCookies(['qme']);

    const [showEditModal, setShowEditModal] = useState(false);
    const handlePostEditModal = () => {
        handleCloseEditModal();
    }
    const handleCloseEditModal = () => setShowEditModal(false);
    const handleShowEditModal = () => {
        setShowEditModal(true)
    }

    function fetchCase() {
        axios.get('/api/backend/ipd/case/fetch/' + props.cookieEntityQr + "/" + props.case.caseId)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setCaseDetails(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {
        if (props.cookieEntityQr && props.case) {
            fetchCase()
        }
    }, [props.cookieEntityQr, props.case])

    const handleCloseCase = () => {
        axios.post('/api/backend/ipd/case/update/status/' + props.case.id + '/CLOSED', null)
            .then(resp => {
                props.clearCaseId()
                console.log(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            })
            .finally(() => setLoading(false))
    }

    function fetchBill(billId, entityQr) {
        axios.get('/api/backend/inventory/sales/order/fetch/' + entityQr + "/" + billId)
            .then(resp => {
                setBillStatus(resp.data.status)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    function getModalForEditCase() {
        return <Modal
            show={showEditModal}
            onHide={handleCloseEditModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <CaseDetailsView cookieEntityQr={props.cookieEntityQr} caseNumber={props.case && props.case.caseId}
                                 doctors={props.doctors}
                                 postAction={handlePostEditModal} createForUhid={null}/>
            </Modal.Body>
        </Modal>;
    }

    const [showBillingModal, setShowBillingModal] = useState(false);
    const handlePostBillingModal = () => {
        fetchCase()
        handleCloseBillingModal();
    }
    const handleCloseBillingModal = () => setShowBillingModal(false);
    const handleShowBillingModal = () => {
        setShowBillingModal(true)
    }

    function getModalForBilling() {
        return <Modal
            show={showBillingModal}
            onHide={handleCloseBillingModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <BillView billId={props.case && props.case.salesOrderNumber} customerId={null}
                          entityQr={props.cookieEntityQr} postAction={handlePostBillingModal} source={"IPD"}/>
            </Modal.Body>
        </Modal>;
    }

    const [showDischargeModal, setShowDischargeModal] = useState(false);
    const handleCloseDischargeModal = () => setShowDischargeModal(false);
    const handleShowDischargeModal = () => {
        setShowDischargeModal(true)
    }

    function getModalForDischarge() {
        return <Modal
            show={showDischargeModal}
            onHide={handleCloseDischargeModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <DischargeSummary trackId={props.case.trackId} isFromLink={false} doctors={props.doctors}/>
            </Modal.Body>
        </Modal>;
    }

    const [showCaseFileModal, setShowCaseFileModal] = useState(false);
    const handlePostCaseFileModal = () => {
        handleCloseCaseFileModal();
    }
    const handleCloseCaseFileModal = () => setShowCaseFileModal(false);
    const handleShowCaseFileModal = () => {
        setShowCaseFileModal(true)
    }

    function getModalForCaseFile() {
        return <Modal
            show={showCaseFileModal}
            onHide={handleCloseCaseFileModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <CaseFile caseId={props.case.trackId} doctors={props.doctors} stateTracker={stateTracker} uploads={caseDetails && caseDetails.uploads ? JSON.parse(caseDetails.uploads) : []}/>
            </Modal.Body>
        </Modal>;
    }

    const [showAddRecordModal, setShowAddRecordModal] = useState(false);

    const handleCloseAddRecordModal = () => {
        setShowAddRecordModal(false);
        setStateTracker(random(2));
    }
    const handleShowAddRecordModal = () => {
        setShowAddRecordModal(true)
    }

    function getModalForAddRecord() {
        return <Modal
            show={showAddRecordModal}
            onHide={handleCloseAddRecordModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <AddRecordView cookieEntityQr={props.cookieEntityQr} uhid={props.case && props.case.uhid}
                               caseId={props.case && props.case.id} caseNumber={props.case && props.case.caseId}
                               postAction={handleCloseAddRecordModal} category={null} assignedDr={caseDetails && caseDetails.assignedDr}/>
            </Modal.Body>
        </Modal>;
    }

    const [showAddProcedureModal, setShowAddProcedureModal] = useState(false);
    const [currentProcedureData, setCurrentProcedureData] = useState(null);
    const handlePostAddProcedureModal = () => {
        handleCloseAddProcedureModal();
        setStateTracker(random(2));
    }
    const handleCloseAddProcedureModal = () => setShowAddProcedureModal(false);
    const handleShowAddProcedureModal = (data) => {
        setCurrentProcedureData(data)
        setShowAddProcedureModal(true)
    }

    function getModalForAddProcedure() {
        return <Modal
            show={showAddProcedureModal}
            onHide={handleCloseAddProcedureModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <AddProcedureView cookieEntityQr={props.cookieEntityQr} caseId={props.case && props.case.id}
                                  postAction={handlePostAddProcedureModal} doctors={props.doctors}
                                  procedureData={currentProcedureData}/>
            </Modal.Body>
        </Modal>;
    }

    const [showAddDischargeModal, setShowAddDischargeModal] = useState(false);
    const [dischargeData, setDischargeData] = useState(null);
    const handlePostAddDischargeModal = () => {
        handleCloseAddDischargeModal();
        fetchCase()
        setStateTracker(random(2));
    }
    const handleCloseAddDischargeModal = () => setShowAddDischargeModal(false);
    const handleShowAddDischargeModal = () => {
        setShowAddDischargeModal(true)
    }

    function getModalForAddDischarge() {
        return <Modal
            show={showAddDischargeModal}
            onHide={handleCloseAddDischargeModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                {caseDetails &&
                    <AddDischargeDetailsView cookieEntityQr={props.cookieEntityQr} caseDetails={caseDetails}
                                             postAction={handlePostAddDischargeModal} doctors={props.doctors}
                                             id={caseDetails.id}/>}
            </Modal.Body>
        </Modal>;
    }

    const [showAddVisitModal, setShowAddVisitModal] = useState(false);
    const [currentVisitData, setCurrentVisitData] = useState(null);
    const handlePostAddVisitModal = () => {
        handleCloseAddVisitModal();
        setStateTracker(random(2));
    }
    const handleCloseAddVisitModal = () => setShowAddVisitModal(false);
    const handleShowAddVisitModal = (data) => {
        setCurrentVisitData(data)
        setShowAddVisitModal(true)
    }

    function getModalForAddVisitCase() {
        return <Modal
            show={showAddVisitModal}
            onHide={handleCloseAddVisitModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <AddVisitView cookieEntityQr={props.cookieEntityQr} caseId={props.case && props.case.id}
                              postAction={handlePostAddVisitModal} doctors={props.doctors}
                              visitData={currentVisitData}/>
            </Modal.Body>
        </Modal>;
    }

    const [showAddBedModal, setShowAddBedModal] = useState(false);
    const handleCloseAddBedModal = () => {
        setShowAddBedModal(false);
        setStateTracker(random(2));
        fetchCase()
    }
    const handleShowAddBedModal = () => {
        setShowAddBedModal(true)
    }

    function getModalForAddBedCase() {
        return <Modal
            show={showAddBedModal}
            onHide={handleCloseAddBedModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <AddBedView cookieEntityQr={props.cookieEntityQr} caseId={props.case && props.case.id}
                            bedName={caseDetails && caseDetails.bedName}
                            postAction={handleCloseAddBedModal}/>
            </Modal.Body>
        </Modal>;
    }

    const [showPrintConsentFormModal, setShowPrintConsentFormModal] = useState(false);
    const handleClosePrintConsentFormModal = () => {
        setShowPrintConsentFormModal(false);
        setStateTracker(random(2));
        fetchCase()
    }
    const handleShowPrintConsentFormModal = () => {
        setShowPrintConsentFormModal(true)
    }

    function getModalForPrintConsentForm() {
        return <Modal
            show={showPrintConsentFormModal}
            onHide={handleClosePrintConsentFormModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <CaseConsentFormsView caseDetails={caseDetails} dischargeDate={null} cookieEntityQr={props.cookieEntityQr}/>
            </Modal.Body>
        </Modal>;
    }

    const [showFileUploadModal, setShowFileUploadModal] = useState(false);
    const handleCloseFileUploadModal = () => {
        setShowFileUploadModal(false);
        setStateTracker(random(2));
        fetchCase()
    }
    const handleShowFileUploadModal = () => {
        setShowFileUploadModal(true)
    }

    function getModalForFileUpload() {
        return <Modal
            show={showFileUploadModal}
            onHide={handleCloseFileUploadModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <IpdUploadView caseDetails={caseDetails} fetch={fetchCase}/>
            </Modal.Body>
        </Modal>;
    }

    useEffect(() => {
        if (props.cookieEntityQr && props.case) {
            axios.get('/api/backend/ipd/case/fetch/all/' + props.cookieEntityQr + "?uhid=" + props.case.uhid)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setOldCases(resp.data.filter(c => c.id < props.case.id))
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
            fetchBill(props.case.salesOrderNumber, props.cookieEntityQr)
        }
    }, [props.cookieEntityQr, props.case])

    function getHistory() {
        return <>
            {oldCases && oldCases.length > 0 &&
                <div className="bg-lightGrey p-3 border">
                    <h3 className="text-primary text-center">Patient&apos;s History</h3>
                    <Accordion defaultActiveKey="0">
                        {oldCases.map(c => {
                            return <><Accordion.Item key={"doctor-schedule"} eventKey={c.id}>
                                <Accordion.Header>
                                    <div className="fw-bold">{c.caseId}<span
                                        className="fw-normal">&nbsp;&nbsp;-&nbsp;&nbsp;({new Date(c.createdAt).toLocaleDateString("en-GB")})</span>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <table width="100%">
                                        <tr>
                                            <td width="85%">
                                                <TimelineView key={c.id} cookieEntityQr={props.cookieEntityQr} case={c}
                                                              doctors={props.doctors} stateTracker={null}
                                                              editProcedure={handleShowAddProcedureModal}
                                                              editVisit={showAddVisitModal}
                                                              caseStatus={c.status}/>
                                            </td>
                                            <td width="15%"></td>
                                        </tr>
                                    </table>
                                </Accordion.Body>
                            </Accordion.Item></>
                        })}
                    </Accordion>
                </div>
            }
        </>
            ;
    }

    return (
        <>
            <div className="card shadow-sm min-vh-100">
                <div className="card-header">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex">
                            <Button className="btn btn-primary" style={{borderRadius: "50%"}}
                                    onClick={e => props.clearCaseId()}>
                                <img
                                    alt="ipd-management"
                                    src="/back.png"
                                    width="14"
                                    height="24"
                                />
                            </Button>&nbsp;&nbsp;&nbsp;
                            <div
                                className="align-self-center text-primary font-weight-bold">
                                Case #: {props.case && props.case.caseId}
                            </div>
                        </div>
                        <div className="d-flex">
                            {hasPermissions(cookie.qme, IPD_BILLING) && <Button
                            className="btn btn-sm btn-outline-primary bg-white text-primary d-inline-block"
                            onClick={handleShowBillingModal}>&#129534; Billing Information</Button>}&nbsp;&nbsp;
                            <Button className="btn btn-sm btn-warning text-white"
                                    onClick={handleShowDischargeModal}>Discharge
                                Summary</Button>&nbsp;&nbsp;
                            {props.case && props.case.status == "DISCHARGED" && (billStatus && billStatus == "PAID") &&
                                <Button className="btn btn-sm btn-danger text-white" onClick={handleCloseCase}>Close
                                    Case</Button>}</div>
                    </div>
                </div>
                <table width="100%" style={{minHeight: "100vh"}}>
                    <tr>
                        <td width="85%" className="align-top">
                            <Tabs
                                defaultActiveKey="timeline"
                                className="fs-5 text-secondary nav-pills fs-6"
                            >
                                <Tab eventKey="timeline" title="&#x1F551; Timeline">
                                    {caseDetails && <div className="m-3"><TimelineView cookieEntityQr={props.cookieEntityQr}
                                                                       case={props.case}
                                                                       doctors={props.doctors}
                                                                       stateTracker={stateTracker}
                                                                       editProcedure={handleShowAddProcedureModal}
                                                                       editVisit={handleShowAddVisitModal}
                                                                       caseStatus={caseDetails.status}/></div>}
                                </Tab>
                                <Tab eventKey="details" title="✎ Patient Details">
                                    <div className="m-3"><CaseDetailsView cookieEntityQr={props.cookieEntityQr}
                                                                          caseNumber={props.case && props.case.caseId}
                                                                          doctors={props.doctors}
                                                                          postAction={handlePostEditModal}
                                                                          createForUhid={null}/></div>
                                </Tab>
                            </Tabs>
                        </td>
                        <td width="15%" className="bg-light align-top">
                            <div className="text-left ml-4 mt-3">
                                {props.case.status != "CLOSED" && <>
                                    <div className="my-2"><a href="#/" className="text-primary text-decoration-none"
                                                             onClick={handleShowAddVisitModal}>Add Visit Details</a>
                                    </div>
                                    <div className="my-2"><a href="#/" className="text-primary text-decoration-none"
                                                             onClick={handleShowAddRecordModal}>Add Investigations/Service Records</a>
                                    </div>
                                    <div className="my-2"><a href="#/" className="text-primary text-decoration-none"
                                                             onClick={handleShowAddProcedureModal}>Add Procedure/Surgery
                                        Details</a>
                                    </div>
                                    <div className="my-2"><a href="#/" className="text-primary text-decoration-none"
                                                             onClick={handleShowAddBedModal}>Assign/Unassign Bed</a>
                                    </div>
                                    <div className="my-2"><a href="#/" className="text-primary text-decoration-none"
                                                             onClick={handleShowPrintConsentFormModal}>Print Consent Forms</a>
                                    </div>
                                    <div className="my-2"><a href="#/" className="text-primary text-decoration-none"
                                                             onClick={handleShowFileUploadModal}>File Uploads</a>
                                    </div>
                                    {caseDetails && caseDetails.status == "ACTIVE" &&
                                        <div className="my-2"><a href="#/" className="text-primary text-decoration-none"
                                                                 onClick={handleShowAddDischargeModal}>Discharge
                                            patient</a>
                                        </div>}
                                </>}
                                <div className="my-2">
                                    <a href="#/" className="text-primary text-decoration-none"
                                       onClick={handleShowCaseFileModal}
                                    >Case File</a>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
                {getHistory()}
                {getModalForEditCase()}
                {getModalForBilling()}
                {getModalForDischarge()}
                {getModalForAddRecord()}
                {getModalForAddProcedure()}
                {getModalForAddDischarge()}
                {getModalForAddVisitCase()}
                {getModalForAddBedCase()}
                {getModalForCaseFile()}
                {getModalForPrintConsentForm()}
                {getModalForFileUpload()}
            </div>
        </>
    );
}
